"use strict";

exports.__esModule = true;
exports.NonLinearAds = void 0;
var _StringUtils = require("../Utils/StringUtils");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var NonLinearAds = exports.NonLinearAds = /*#__PURE__*/function () {
  function NonLinearAds(trackingMap, nonLinearCreatives) {
    /** @private */
    this.trackingMap = trackingMap ? trackingMap : new Map();
    /** @private */
    this.nonLinearCreatives = nonLinearCreatives ? nonLinearCreatives : [];
  }
  var _proto = NonLinearAds.prototype;
  _proto.allNonLinearsAreInactive = function allNonLinearsAreInactive() {
    for (var _iterator = _createForOfIteratorHelperLoose(this.nonLinearCreatives), _step; !(_step = _iterator()).done;) {
      var nlc = _step.value;
      if (nlc.isVisible()) {
        return false;
      }
    }
    return true;
  };
  _proto.containsCreative = function containsCreative(creative) {
    return this.nonLinearCreatives.indexOf(creative) !== -1;
  };
  _proto.getNonLinearCreatives = function getNonLinearCreatives() {
    return Object.assign([], this.nonLinearCreatives);
  };
  _proto.getNonLinearCreativesByType = function getNonLinearCreativesByType(type) {
    var arr = [];
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.nonLinearCreatives), _step2; !(_step2 = _iterator2()).done;) {
      var nlc = _step2.value;
      if (nlc.getResource(type)) {
        arr.push(nlc);
      }
    }
    return arr;
  };
  _proto.getTrackingMap = function getTrackingMap() {
    return this.trackingMap;
  };
  _proto.getTrackingReport = function getTrackingReport(type) {
    if (this.allNonLinearsAreInactive()) {
      return undefined;
    }
    return this.trackingMap.get(type);
  };
  _proto.postParse = function postParse() {
    // provide a reference to tracking to allow nonlinear creatives to request
    // autonomously to the AnalyticBroker
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.nonLinearCreatives), _step3; !(_step3 = _iterator3()).done;) {
      var nlc = _step3.value;
      nlc.setTrackingReports(this.trackingMap);
    }
  };
  _proto.prefetchResources = function prefetchResources(timeout) {
    for (var _iterator4 = _createForOfIteratorHelperLoose(this.nonLinearCreatives), _step4; !(_step4 = _iterator4()).done;) {
      var nlc = _step4.value;
      nlc.prefetchResources(timeout);
    }
  };
  _proto.toString = function toString() {
    if (this.nonLinearCreatives.length > 0) {
      var s = "\n--- NonLinear Ads:";
      if (this.trackingMap.size > 0) {
        s += "\n  ** Tracking events - ";
        for (var _iterator5 = _createForOfIteratorHelperLoose(this.trackingMap), _step5; !(_step5 = _iterator5()).done;) {
          var _step5$value = _step5.value,
            key = _step5$value[0],
            value = _step5$value[1];
          s += (0, _StringUtils.toIndentedString)("\n " + key + ":" + value);
        }
      }
      for (var _iterator6 = _createForOfIteratorHelperLoose(this.nonLinearCreatives), _step6; !(_step6 = _iterator6()).done;) {
        var nlc = _step6.value;
        s += (0, _StringUtils.toIndentedString)(nlc);
      }
      return s;
    }
    return "";
  };
  return NonLinearAds;
}();